const monthlyPassParkingReducer = (previousState = {}, { type, payload }) => {
    if (type === 'UPDATE_MONTHLY_PASS_PARKING') {
        return payload.monthlyPassParking;
    }
    return previousState;
}
export default monthlyPassParkingReducer;